import { Validators } from "@angular/forms";

export const createMappingTemplate = {
  createMapping: [
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-6",
          key: "name",
          type: "input",
          templateOptions: {
            label: "Test Case Mapping Name",
            required: true,
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        },
        {
          className: "col-md-6",
          key: "testCaseVersion",
          type: "select",
          templateOptions: {
            label: "Select Versioning of Test Cases",
            placeholder: "Select an option",
            required: true,
            options:  []
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ],
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-6",
          key: "vectorDatabase",
          type: "select",
          templateOptions: {
            label: "Vector Database",
            placeholder: "Select an option",
            required: true,
            options: [
              {
                label: "Pinecone",
                value: "pinecone",
              }
            ],
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        },
        {
          className: "col-md-6",
          key: "pineconeApiKey",
          type: "input",
          templateOptions: {
            label: "Pinecone API Key",
            type: "password",
            required: true,
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-6",
          key: "embeddingModel",
          type: "select",
          templateOptions: {
            label: "Embedding Model",
            placeholder: "Select an option",
            required: true,
            options: [
              {
                label: "OpenAI-text-embedding-3-small",
                value: "openai-text-embedding-3-small",
              }
            ],
          },
          hideExpression: true,
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        },
        {
          className: "col-md-6",
          key: "openaiApiKey",
          type: "input",
          templateOptions: {
            label: "Open AI API Key",
            type: "password",
            required: true,
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ],
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-6",
          key: "githubLink",
          type: "input",
          templateOptions: {
            label: "GitHub Repo Link",
            required: true,
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        },
        {
          className: "col-md-6",
          key: "githubToken",
          type: "input",
          templateOptions: {
            label: "GitHub Token",
            type: "password",
            required: true,
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ],
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-6",
          key: "languageModel",
          type: "select",
          templateOptions: {
            label: "Language Model",
            placeholder: "Select an option",
            required: true,
            options: [
              {
                label: "GPT 3.5",
                value: "gpt3.5",
              }
            ],
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ],
    }
  ],
};

export const editMappingTemplate = {
  formDescription: [
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-12 formly-textarea",
          key: "projectDescription",
          type: "textarea",
          templateOptions: {
            label: 'Project Description',
            required: true
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ]
    }
  ],
  formGitHubLink: [
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-12",
          key: "gitHubRepoLink",
          type: "input",
          templateOptions: {
            label: 'GitHub Repo Link',
            required: true
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ]
    }
  ],
  formSpecifications: [
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-12",
          key: "vectorDatabase",
          defaultValue: 'pinecone',
          type: "select",
          templateOptions: {
            label: 'Vector Database',
            required: true,
            options: [
              {
                label: 'Pinecone',
                value: 'pinecone'
              },
              {
                label: 'ChromaDB',
                value: 'chromaDB'
              },
              {
                label: 'Faiss',
                value: 'faiss'
              }
            ]
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ]
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-12",
          key: "embeddingModel",
          defaultValue: 'openai-text-embedding-3-small',
          type: "select",
          templateOptions: {
            label: 'Embedding Model',
            required: true,
            options: [
              {
                label: 'OpenAI-text-embedding-3-small',
                value: 'openai-text-embedding-3-small'
              },
              {
                label: 'text-embedding-ada-002',
                value: 'text-embedding-ada-002'
              },
              {
                label: 'distilbert-base-uncased',
                value: 'distilbert-base-uncased'
              }
            ]
          },
          hideExpression: true,
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ]
    },
    {
      fieldGroupClassName: "row",
      fieldGroup: [
        {
          className: "col-md-12",
          key: "languageModel",
          defaultValue: 'gpt3.5',
          type: "select",
          templateOptions: {
            label: 'Language Model',
            required: true,
            options: [
              {
                label: 'GPT 3.5',
                value: 'gpt3.5'
              },
              {
                label: 'GPT 4',
                value: 'gpt4'
              },
              {
                label: 'Gemini',
                value: 'gemini'
              }
            ]
          },
          validation: {
            messages: {
              required: () => "This field is required.",
            },
          },
        }
      ]
    }
  ]
};

export const userPermisionAdminViewTemplate = [
  // {
  //   fieldGroupClassName: "row",
  //   fieldGroup: [
  //     {
  //       className: "col-md-6",
  //       key: "firstName",
  //       type: "input",
  //       templateOptions: {
  //         placeholder: "Enter the first name",
  //         required: true,
  //       },
  //       validation: {
  //         messages: {
  //           required: "First Name is required.",
  //         },
  //       },
  //     },
  //     // {
  //     //   className: "col-md-6",
  //     //   key: "lastName",
  //     //   type: "input",
  //     //   templateOptions: {
  //     //     placeholder: "Enter the last name",
  //     //     required: true,
  //     //   },
  //     //   validation: {
  //     //     messages: {
  //     //       required: "Last Name is required.",
  //     //     },
  //     //   },
  //     // },
  //   ],
  // },
  {
    className: "col-md-12",
    key: "email",
    type: "input",
    templateOptions: {
      placeholder: "Enter the email address",
      type: "email",
      required: true,
    },
    validators: {
      validation: [Validators.email],
    },
    validation: {
      messages: {
        required: "Email is required.",
        email: "Please enter a valid email address.",
      },
    },
  },
];

export const connectionJiraTemplate =  [
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "connectionName",
        type: "input",
        templateOptions: {
          label: "Connection Name",
          placeholder: "Connection Name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "baseUrl",
        type: "input",
        templateOptions: {
          label: "Domain URL",
          placeholder: "Domain URL",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "username",
        type: "input",
        templateOptions: {
          label: "Username",
          placeholder: "Username",
          required: false,
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "project",
        type: "input",
        templateOptions: {
          label: "Project Name",
          placeholder: "Project Name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "apiKey",
        type: "input",
        templateOptions: {
          label: "API Key",
          placeholder: "API Key",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
];

export const connectionLLMTemplate = [
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "llmConnName",
        type: "input",
        templateOptions: {
          label: "Connection Name",
          placeholder: "Connection Name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "llmBaseUrl",
        type: "input",
        templateOptions: {
          label: "Base URL",
          placeholder: "Base URL",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "llmModelName",
        type: "input",
        templateOptions: {
          label: "Model Name",
          placeholder: "Model Name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "llmApiKey",
        type: "input",
        templateOptions: {
          label: "API Key",
          placeholder: "API Key",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
];

export const connectionFileTemplate =  (selectedFile: any, rootStyles: any) => ([
  // [0] Connection Name
  {
    className: "col-md-12",
    key: "connectionName",
    type: "input",
    templateOptions: {
      label: "Connection Name",
      placeholder: "add connection name",
      required: true,
    },
    validation: {
      messages: {
        required: () => "This field is required.",
      },
    },
  },
  // [1] Type + Target Asset (side-by-side)
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-6",
        key: "type",
        type: "select",
        defaultValue: "local",
        templateOptions: {
          label: "Type",
          required: true,
          options: [
            { value: "local", label: "Local" },
            { value: "s3",    label: "S3" },
          ],
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
      {
        className: "col-md-6",
        key: "targetAsset",
        type: "select",
        templateOptions: {
          label: "Target Asset",
          placeholder: "Select target asset",
          required: true,
          options: [
            { value: "testCaseGenerator",  label: "Test Case Generator" },
            { value: "testDataGeneration", label: "Test Data Generation" },
            { value: "scriptGenerator", label: "Test Script Generator" },
          ],
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  // [2] Access Key ID (S3 only)
  {
    className: "col-md-12",
    key: "accessKeyID",
    type: "input",
    templateOptions: {
      label: "Access Key ID",
      placeholder: "Access Key ID",
      required: true,
    },
    validation: {
      messages: {
        required: () => "This field is required.",
      },
    },
    hideExpression: (model: { type: string }) => model.type !== "s3",
  },
  // [3] Secret Access Key (S3 only)
  {
    className: "col-md-12",
    key: "accessKeySecret",
    type: "input",
    templateOptions: {
      label: "Secret Access Key",
      placeholder: "Secret Access Key",
      required: true,
    },
    validation: {
      messages: {
        required: () => "This field is required.",
      },
    },
    hideExpression: (model: { type: string }) => model.type !== "s3",
  },
  // [4] S3 Bucket Name (S3 only)
  {
    className: "col-md-12",
    key: "s3BucketName",
    type: "input",
    templateOptions: {
      label: "Bucket Name",
      placeholder: "S3 Bucket Name",
      required: true,
    },
    validation: {
      messages: {
        required: () => "This field is required.",
      },
    },
    hideExpression: (model: { type: string }) => model.type !== "s3",
  },
  // [5] Region (S3 only)
  {
    className: "col-md-12",
    key: "region",
    type: "input",
    templateOptions: {
      label: "Region",
      placeholder: "Region",
      required: true,
    },
    validation: {
      messages: {
        required: () => "This field is required.",
      },
    },
    hideExpression: (model: { type: string }) => model.type !== "s3",
  },
]);

export const adminViewProjectTemplate = [
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-12",
        key: "name",
        type: "input",
        templateOptions: {
          label: "Name",
          placeholder: "Enter project name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
];

export const persistTestCaseTemplate = [
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-6",
        key: "name",
        type: "input",
        templateOptions: {
          label: "Test Case Mapping Name",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
      // {
      //   className: "col-md-6",
      //   key: "testCaseVersion",
      //   type: "select",
      //   templateOptions: {
      //     label: "Select Versioning of Test Cases",
      //     placeholder: "Select an option",
      //     required: true,
      //     options:  []
      //   },
      //   validation: {
      //     messages: {
      //       required: () => "This field is required.",
      //     },
      //   },
      // }
    ],
  },
  {
    fieldGroupClassName: "row",
    fieldGroup: [
      {
        className: "col-md-6",
        key: "vectorDatabase",
        type: "select",
        templateOptions: {
          label: "Vector Database",
          placeholder: "Select an option",
          required: true,
          options: [
            {
              label: "Pinecone",
              value: "pinecone",
            }
          ],
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
      {
        className: "col-md-6",
        key: "pineconeApiKey",
        type: "input",
        templateOptions: {
          label: "Pinecone API Key",
          type: "password",
          required: true,
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
 
];

export const signUpViewTemplate =  [
  {
    fieldGroupClassName: "display-flex",
    fieldGroup: [
      {
        className: "flex-1",
        type: "input",
        key: "firstName",
        templateOptions: {
          label: 'Firstname',
          placeholder: "Enter Your Firstname",
          required: true
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
      {
        className: "flex-1",
        type: "input",
        key: "lastName",
        templateOptions: {
          label: 'Lastname',
          placeholder: "Enter Your Lastname",
          required: true
        },
        validation: {
          messages: {
            required: () => "This field is required.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "display-flex",
    fieldGroup: [
      {
        className: "flex-1",
        type: "input",
        key: "email",
        templateOptions: {
          label: 'Email',
          placeholder: "Email",
          type: "email",
          required: true,
          pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        },
        validation: {
          messages: {
            required: () => "This Email is required.",
            email: () => "Please enter a valid email address.",
            pattern: () => "Please enter a valid email address.",
          },
        },
      },
    ],
  },
  {
    fieldGroupClassName: "display-flex",
    fieldGroup: [
      {
        className: "flex-1",
        type: "textarea",
        key: "aboutYou",
        templateOptions: {
          label: 'About You',
          placeholder: "Enter something about yourself",
          rows: 5,
        },
      },
    ],
  },
];